import React, {Component} from 'react';
import Header from './Shared/Header';
import "whatwg-fetch";

class SubscribePageContent extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div>
                {this.props.subscribe.Sliders.length >0 ? (
                    <Header topHeader={this.props.subscribe.Sliders[0]} newClassName={"product-index-visual"} />
                ) : null}
                <div className="main">

                    <section className="unsubscribe subscribe clearfix">
                        <section className="colLeft">
                            <p className="text" dangerouslySetInnerHTML={{"__html": this.props.subscribe.LeftText.Value }}></p>
                        </section>
                        <section className="colRight">
                            <h2>{this.props.subscribe.Title.Value}</h2>
                            <p className="text">{this.props.subscribe.SubTitle.Value}</p>
                            <div id="app" className="subscribe-form"></div>
                        </section>
                    </section>
                </div>
            </div>
        )
    }
}

export default SubscribePageContent;
